export default __webpack_public_path__ + "3df713dd1627ff359ad9aae82e413da5.svg";